import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {useDispatch, useSelector} from "react-redux";
import {Box, Card, Grid, Switch} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {
    bbDoesCustomerHaveAccessToModule,
    bbGetModulePropertyFromIdOrName, isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import BBIconHexModuleYes from "../../../assets/bbCustomIcons/BBIconHexModuleYes";
import BBIconHexModuleNo from "../../../assets/bbCustomIcons/BBIconHexModuleNo";
import {BBModuleIcon} from "../../../util/bbHelpers";
import {Badge} from "reactstrap";
import {activateCustomerModule, deactivateCustomerModule} from "../../../actions";

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
});

const InfoIcon = (props) => {
    // const {authUser} = useSelector(({auth}) => auth);
    const {customers, customerInView} = useSelector(({customer}) => customer);
  const {module,
      customerId = null,
      iconOnly = false,
      yesNoIconOnly = false,
      iconSize = "65px"} = props;

  const customerIdToUse = customerId ? customerId : customerInView ? customerInView : null;
  const customer = customers ? customerIdToUse ? customers[customerIdToUse] ? customers[customerIdToUse] : null : null : null;
    const authUser = useSelector(({auth}) => auth.authUser);
    const dispatch = useDispatch();



    const doShowControls = isCurrentUserMemberOf(authUser, "admin")

    const moduleName = bbGetModulePropertyFromIdOrName(module, "longName");
    const moduleDescription = bbGetModulePropertyFromIdOrName(module, "description");

    const [switchState, setSwitchStateState] = React.useState({
        monitor: bbDoesCustomerHaveAccessToModule(customer, "monitor"),
        perimeter: bbDoesCustomerHaveAccessToModule(customer, "perimeter"),
        insider: bbDoesCustomerHaveAccessToModule(customer, "insider"),
        social: bbDoesCustomerHaveAccessToModule(customer, "social"),
        cmmc: bbDoesCustomerHaveAccessToModule(customer, "cmmc"),
    });

    const handleChange = (event) => {
        setSwitchStateState({ ...switchState, [event.target.name]: event.target.checked });

        //send the proper dispatch to add or delete activtate deactivate the module
        const moduleIdToManipulate = bbGetModulePropertyFromIdOrName(event.target.name, "id");

        if (moduleIdToManipulate) {
            if (event.target.checked) {
                //It was deactivated, so activate it
                dispatch(activateCustomerModule({
                    customerId: customerIdToUse,
                    moduleId:moduleIdToManipulate
                }));
            } else {
                //it was activated, so deactivate it
                dispatch(deactivateCustomerModule({
                    customerId: customerIdToUse,
                    moduleId:moduleIdToManipulate
                }));
            }
        }

    };

  const iconToDisplayYesOrNo = () => {
      if (bbDoesCustomerHaveAccessToModule(customer, module)) {
          return <Tooltip title={`${moduleName} module is active.`}><span><BBIconHexModuleYes style={{fontSize: iconSize}} className={"text-electric-blue "}/></span></Tooltip>
      } else {
          return <Tooltip title={`${moduleName} is not active.`}><span><BBIconHexModuleNo style={{fontSize: iconSize}} className={"text-grey "}/></span></Tooltip>
      }
    }

    const iconToDisplay = () => {
        if (bbDoesCustomerHaveAccessToModule(customer, module)) {
            return <Tooltip title={`${moduleName} module is active.`}>
                <span>
                    <BBModuleIcon module={module} iconSize={iconSize} className={"text-electric-blue"}/>
                    {doShowControls &&
                    <><br/>
                        <Switch
                            checked={bbDoesCustomerHaveAccessToModule(customer, module)}
                            onChange={handleChange}
                            color="secondary"
                            size="small"
                            name="perimeter"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                    </>

                    }
                </span>
            </Tooltip>
        } else {
            return <Tooltip title={`${moduleName} module is not active.`}>
                <span>
                    <BBModuleIcon module={module} iconSize={iconSize} isActive={false} className={"text-grey"}/>
                    {doShowControls &&
                    <><br/>
                        <Switch
                            checked={bbDoesCustomerHaveAccessToModule(customer,module)}
                            onChange={handleChange}
                            color="secondary"
                            size="small"
                            name={moduleName}
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                    </>
                    }
                </span>
            </Tooltip>
        }
    }

  return (
        <>
            {yesNoIconOnly
                ? iconToDisplayYesOrNo()
                : iconOnly
                ? iconToDisplay()
                : <Card className={`bg-light animated fadeIn animation-duration-5 d-flex flex-row my-2`}
                        style={{borderLeft: "12px solid gray", padding: "3px", paddingTop: "7px"}} elevation={3}>

                    <Grid container
                          spacing={0}
                          alignItems="stretch"
                          justifyContent="center"
                          direction="row"
                    >
                        <Grid item xs={4}>
                            <Box>
                                {iconToDisplay()}
                            </Box>
                            {/*<h5 style={{fontSize: "smaller"}}>Control:</h5>*/}
                        </Grid>
                        <Grid item xs={8}>
                            <h2 className={'bb-font-fridge-bold'}>{moduleName} Module</h2>
                            {bbDoesCustomerHaveAccessToModule(customer, module)
                                ? <Badge color="electric-blue-light">Enabled</Badge>
                                : <Badge color="grey">Disabled</Badge>
                            }
                        </Grid>
                    </Grid>
                    <div style={{marginLeft: "auto", marginTop: "-6px"}}>
                        <Tooltip
                            title={`This widget checks to see if you have access to the ${moduleName} module. | ${moduleDescription}`}>
                            <InfoSharpIcon style={{fontSize: "20px",}} className={`text-muted`}/>
                        </Tooltip>
                    </div>
                </Card>

            }
        </>

  );

}

InfoIcon.propTypes = {
  module: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    customerId: PropTypes.string,
    iconOnly :PropTypes.bool,
    iconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default withStyles(styles)(InfoIcon);